var defaultImg=getAbsoluteUrl(require("../img/favicon_b.png"));
function getAbsoluteUrl (url) {
    var a = document.createElement('a');
    a.href = url;
    return a.href;
}
function Bullet(obj,trajectory){
	var _this=this;
	this.trajectory=trajectory;
	this.txt=obj.content;
	var activeClass="";
	if(obj.hasZan==1){
		activeClass="active";
	}
	if(obj.headImgKey){
		this.$el=$('<span class="bullet '+activeClass+'" data-id="'+obj.commentId+'"><span class="icon-zan"></span><img src="'+obj.headImgKey+'">'+obj.content+'</span>');
	}else{
		this.$el=$('<span class="bullet '+activeClass+'" data-id="'+obj.commentId+'"><span class="icon-zan"></span><img src="'+defaultImg+'">'+obj.content+'</span>');
	}	
	this.$el.css("left",this.startPosX);
	$(".bulletScreen").append(this.$el);
	this.w=this.$el.outerWidth();
	this.containerWidth=$(".g-wrap").width();
	this.speed=this.w/7+this.containerWidth/7;
	this.init();
	this.animate();
	this.isTrigger=false;
	this.$el.click(function(){		
		if($(this).hasClass("active")){
			$(this).removeClass("active");
			// _this.zan(obj.commentId,0);
			window.main.zan(obj.commentId,0);
		}else{
			$(this).addClass("active");
			// _this.zan(obj.commentId,1);
			window.main.zan(obj.commentId,1);
		}
	})
}

// Bullet.prototype.zan=function(id,type){
// 	$.getJSON("/yubashuo/zan-comment?commentId="+id+"&type="+type,function(msg){
// 		if(msg.resCode!=0){
// 			alert(msg.resReason);
// 			return;
// 		}
// 		if(type==0){
// 			var num=$(".zanBtn[data-id="+id+"]").find(".num").html();
// 			num=parseInt(num);
// 			num--;
// 			$(".zanBtn[data-id="+id+"]").find(".num").html(num);
// 			$(".zanBtn[data-id="+id+"]").find(".icon-zan").removeClass("icon-zan-1");
// 			$(".zanBtn[data-id="+id+"]").attr("data-haszan","0");
// 		}
// 		if(type==1){
// 			var num=$(".zanBtn[data-id="+id+"]").find(".num").html();
// 			num=parseInt(num);
// 			num++;
// 			$(".zanBtn[data-id="+id+"]").find(".num").html(num);
// 			$(".zanBtn[data-id="+id+"]").find(".icon-zan").addClass("icon-zan-1");
// 			$(".zanBtn[data-id="+id+"]").attr("data-haszan","1");
// 		}
// 	})
// }

Bullet.prototype.init=function(){
	var txtLength=this.txt.length;
	var space=txtLength*10;
	this.left=this.containerWidth+space;
	this.time=7/(this.containerWidth+this.w)*(this.left+this.w);
	TweenMax.set(this.$el,{left:this.left,top:this.trajectory*60/100+60/100+"rem"});
}

Bullet.prototype.animate=function(){
	var width=this.$el.outerWidth()
	var _this=this;
	TweenMax.to(this.$el,this.time,{left:-width,ease:Power0.easeNone,onComplete:function(){
		_this.destroy();
	},onUpdate:function(){
		if(_this.isTrigger){
			return;
		}
		var left=_this.$el.css("left");
		left=parseInt(left.substr(0,left.length-2));
		var endX=_this.w+left;
		if(endX<_this.containerWidth){
			_this.isTrigger=true;
			window.main.addNewBullet(_this.trajectory);
		}		
	}});
}

Bullet.prototype.update=function(){
	var x=this.$el.css("left");
	x-=this.speed;
	this.$el.css("left",x);
}

Bullet.prototype.destroy=function(){
	TweenMax.killTweensOf(this.$el);
	this.$el.remove();
	this.$el=null;
}

module.exports=Bullet;


//////////////////
// WEBPACK FOOTER
// ./pages/yubashuo/js/Bullet.js
// module id = 4
// module chunks = 2